<template>
  <div class="wx-mater-drafts">
    <div style="display: flex">
      <div class="big-menu-box" :style="{ height: content_height + 'px' }">
         

        <div style="margin-bottom: 10px">
          <a-input-search
            placeholder="搜索公众号"
            style="width: 192px"
            @search="onSearchGzh($event, 'search_button')"
          />
        </div>

        <div
          v-if="!nav_select_control"
          @click="nav_select_control = true"
          style="
            text-align: right;
            margin-bottom: 7px;
            color: #1d99ff;
            cursor: pointer;
            user-select: none;
          "
        >
          批量选择
        </div>
        <div v-else style="display: flex; justify-content: space-between">
          <div>已选{{ gzhSelectData.length }}个</div>
          <div
            @click="plSelectConfirm"
            style="
              text-align: right;
              margin-bottom: 7px;
              color: #1d99ff;
              cursor: pointer;
              user-select: none;
            "
          >
            完成选择
          </div>
        </div>

        <div class="left-menu-box" :style="{ height: left_book_height + 'px' }">
          <div
            v-if="all_select_control"
            class="left-label"
            style="padding-left: 25px"
            @click="changeAllMenu()"
            :class="[all_style_status ? 'left-children-cell-true' : '']"
          >
            <span style="">全部</span>
          </div>

          <div v-for="(item, index) in menuData" :key="index">
            <div
              class="left-label"
              @click="changeMenu(item, index)"
              :style="{ color: item.style_status ? '#1d99ff' : '' }"
            >
              <a-icon
                v-if="!item.select_status"
                class="nav-icon"
                type="caret-right"
              />
              <a-icon
                v-else-if="item.select_status"
                class="nav-icon"
                type="caret-down"
              />
              <div v-show="nav_select_control" @click.stop>
                <a-checkbox
                  @change.stop="checkA($event, item)"
                  :checked="item.check_status"
                  :indeterminate="item.check_indeterminate"
                  style="margin-right: 10px"
                ></a-checkbox>
              </div>

              <span style="user-select: none">{{ item.name }}</span>
            </div>

            <template v-if="item.select_status">
              <template v-for="ite_z in item.value">
                <div
                  v-if="item.name != '未分组'"
                  @click="changeMenuB(ite_z)"
                  style="padding-left: 20px"
                  class="left-label"
                >
                  <a-icon
                    v-if="!ite_z.status"
                    class="nav-icon"
                    type="caret-right"
                  />
                  <a-icon
                    v-else-if="ite_z.status"
                    class="nav-icon"
                    type="caret-down"
                  />
                  <div v-show="nav_select_control" @click.stop>
                    <a-checkbox
                      @change="checkB($event, ite_z, item)"
                      :checked="ite_z.check_status"
                      :indeterminate="ite_z.check_indeterminate"
                      style="margin-right: 10px"
                    ></a-checkbox>
                  </div>
                  {{ ite_z.name }}
                </div>

                <template v-if="ite_z.status">
                  <div
                    v-for="(item_z, index_z) in ite_z.value"
                    :class="[
                      item_z.click_status ? 'left-children-cell-true' : '',
                    ]"
                    @click="menuSecond(item_z, index_z, item)"
                    class="left-children-cell"
                    style="display: flex"
                  >
                    <div v-show="nav_select_control" @click.stop>
                      <a-checkbox
                        @change="checkC($event, item_z, item)"
                        v-model="item_z.check_status"
                        style="margin-right: 10px"
                      ></a-checkbox>
                    </div>
                    {{ item_z.gzh_name }}
                  </div>
                </template>
              </template>
            </template>
          </div>
        </div>
      </div>

      <!-- 右侧内容 -->
      <div style="flex: 1; margin-left: 15px">
        <!-- 草稿箱与发表记录切换 -->
        <div style="display: flex; margin-bottom: 15px">
          <div
            v-for="item in tabData"
            :key="item.key"
            class="tab-box"
            :class="[item.status ? 'tab-box-true' : '']"
            @click="tabChagen(item)"
          >
            {{ item.label }}
          </div>
        </div>

        <div style="background-color: #fff; padding: 20px 15px 20px 25px">
          <div style="margin-bottom: 5px">
            已选公众号：
            <span>{{ gzhShowData.length }}个</span>
          </div>

          <div
            v-show="gzhShowData.length == 0"
            style="color: #888888; padding: 10px 0 15px; text-align: center"
          >
            请选择公众号后操作
          </div>
          <div
            v-show="gzhShowData.length > 0"
            class="gzh-select-box"
            :class="[
              gzh_select_visible
                ? 'gzh-select-box-show'
                : 'gzh-select-box-hidden',
            ]"
          >
            <template v-if="page_type == 1">
              <div
                v-for="item in gzhShowData"
                :key="item.id"
                class="gzh-select-cell"
                :class="[
                  item.selecte_num > 1 ? 'gzh-select-cell-d' : '',
                  item.selecte_num == 1 ? 'gzh-select-cell-a' : '',
                ]"
                @click="singleGzh(item)"
                style="cursor: pointer"
              >
                {{ item.gzh_name }}
                <span
                  >（已选 {{ item.selecte_num }}/{{ item.draft_count }}
                </span>
                <span>{{ item.tag_name }}</span>
                <span style="margin: 0 6px"
                  >{{ item.tags_count }}/{{ item.user_count }}</span
                >
                <span>{{ item.default_per }}%</span> ）
              </div>
            </template>
            <template v-else>
              <div
                v-for="item in gzhShowData"
                :key="item.id"
                class="gzh-select-cell"
                @click="singleGzh(item)"
              >
                <span style="padding-right: 10px; padding-left: 5px">{{
                  item.gzh_name
                }}</span>
                <template v-if="pl_cancel_gzh">
                  <a-icon
                    @click.stop="selectPlGzh(item)"
                    v-if="!item.select_show"
                    class="select-icon"
                    style="color: #ccc"
                    type="check-circle"
                    theme="filled"
                  />
                  <a-icon
                    @click.stop="selectPlGzh(item)"
                    v-else
                    class="select-icon"
                    style="color: #62a8ea"
                    type="check-circle"
                    theme="filled"
                  />
                </template>
              </div>
            </template>
          </div>

          <div
            v-show="gzhShowData.length > 0"
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 15px;
            "
          >
            <div v-if="page_type == 1" style="display: flex; font-size: 12px">
              <div style="margin-right: 5px">草稿箱选择状态：</div>
              <div style="margin-right: 10px; color: #99918e">
                未选择草稿（{{ gzh_no_select_num }}个）
              </div>
              <div style="color: #e85a32">
                选择多个草稿（{{ gzh_select_num }}个）
              </div>
            </div>
            <div v-else></div>

            <div style="display: flex; font-size: 14px">
              <div
                v-show="!gzh_select_visible"
                style="cursor: pointer; color: #62a8ea"
                @click="gzh_select_visible = true"
              >
                查看全部
              </div>
              <div
                v-show="gzh_select_visible"
                style="cursor: pointer; color: #62a8ea"
                @click="gzh_select_visible = false"
              >
                收起内容
              </div>

              <div
                v-if="page_type == 1"
                style="display: flex; align-items: center"
              >
                <div
                  @click="syncWxDraft"
                  style="
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-left: 25px;
                  "
                >
                  <a-icon
                    style="color: #62a8ea; font-size: 16px"
                    type="cloud-download"
                  />
                  <div style="color: #62a8ea; margin-left: 7px">
                    同步微信草稿箱
                  </div>
                </div>

                <div
                  @click="RefreshButton"
                  style="
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-left: 30px;
                  "
                >
                  <a-icon
                    :spin="sync_true"
                    style="color: #62a8ea"
                    type="sync"
                  />
                  <div style="color: #62a8ea; margin-left: 7px">刷新</div>
                </div>

                <div
                  @click="draftSendHandle(1)"
                  style="
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-left: 30px;
                  "
                >
                  <a-icon
                    style="color: #62a8ea; font-size: 18px; margin-top: -2px"
                    type="bars"
                  />
                  <div style="color: #62a8ea; margin-left: 7px">
                    批量群发（{{ draftSelected.length }}）
                  </div>
                </div>

                <div
                  @click="draftSendHandle(2)"
                  style="
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-left: 20px;
                  "
                >
                  <a-icon
                    style="color: #62a8ea; font-size: 18px; margin-top: -2px"
                    type="bars"
                  />
                  <div style="color: #62a8ea; margin-left: 7px">
                    批量删除（{{ draftSelected.length }}）
                  </div>
                </div>
              </div>
              <template v-else-if="page_type == 2">
                <div
                  v-if="!pl_cancel_gzh"
                  style="
                    cursor: pointer;
                    color: #62a8ea;
                    cursor: pointer;
                    margin-left: 30px;
                  "
                  @click="pl_cancel_gzh = true"
                >
                  批量取消已选
                </div>
                <div
                  v-else
                  style="
                    cursor: pointer;
                    color: #62a8ea;
                    cursor: pointer;
                    margin-left: 30px;
                    display: flex;
                    align-items: center;
                  "
                >
                  <div
                    @click.stop="confirmSelectGzh"
                    style="margin-right: 10px"
                  >
                    确认
                  </div>
                  <div @click.stop="cancelSelectGzh">取消</div>
                </div>

                <div
                  @click="RefreshButton"
                  style="
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-left: 30px;
                  "
                >
                  <a-icon
                    :spin="sync_true"
                    style="color: #62a8ea"
                    type="sync"
                  />
                  <div style="color: #62a8ea; margin-left: 7px">刷新</div>
                </div>

                <div
                  @click="delRecordHandle(2)"
                  style="
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-left: 30px;
                  "
                >
                  <a-icon style="color: #62a8ea" type="copy" />
                  <div style="color: #62a8ea; margin-left: 10px">
                    创建草稿（{{ selectedData.length }}）
                  </div>
                </div>

                <div
                  @click="delRecordHandle(1)"
                  style="
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-left: 20px;
                  "
                >
                  <a-icon style="color: #62a8ea" type="delete" />
                  <div style="color: #62a8ea; margin-left: 10px">
                    删除（{{ selectedData.length }}）
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- 标题 -->
        <!-- <div class="page-title" style="font-size: 20px;margin-bottom: 15px;padding-top: 3px;">{{title_gzh_name || '请先选择公众号'}}</div> -->

        <div
          style="
            background-color: #fff;
            margin-top: 15px;
            padding: 30px 5px 35px 25px;
          "
        >
          <!-- 草稿箱 -->
          <div v-if="page_type == 1">
            <!-- 分页 -->
            <div
              style="margin-bottom: 30px; display: flex; align-items: center"
            >
              <a-pagination
                size="small"
                v-model="r_page"
                :pageSize="r_limit"
                :total="table_total"
                :showTotal="(total, range) => `共 ${total} 条`"
                @change="paginationChange"
                show-quick-jumper
                show-size-changer
                :pageSizeOptions="['12', '20', '50', '80', '100']"
                @showSizeChange="onShowSizeChange"
              />

              <div
                v-show="gzhShowData.length > 0"
                @click="selectDraftAll(1)"
                style="margin: 0 20px; color: #62a8ea; cursor: pointer"
              >
                全选
              </div>
              <div
                v-show="gzhShowData.length > 0"
                @click="selectDraftAll(2)"
                style="margin-right: 20px; color: #62a8ea; cursor: pointer"
              >
                取消全选
              </div>

              <div
                v-if="Object.keys(single_gzh).length > 0"
                class="gzh-select-cell gzh-hover"
                :class="[
                  single_gzh.selecte_num > 1 ? 'gzh-select-cell-d' : '',
                  single_gzh.selecte_num == 1 ? 'gzh-select-cell-a' : '',
                ]"
                style="margin-bottom: 0"
              >
                {{ single_gzh.gzh_name }}（已选 {{ single_gzh.selecte_num }}/{{
                  single_gzh.draft_count
                }}
                <span>{{ single_gzh.tag_name }}</span>
                <span style="margin: 0 6px"
                  >{{ single_gzh.tags_count }}/{{ single_gzh.user_count }}</span
                >
                <span>{{ single_gzh.default_per }}%</span> ）

                <a-icon
                  @click="delSingleGzh"
                  class="gzh-hover-icon"
                  type="close-circle"
                  theme="filled"
                />
              </div>
            </div>
            <div>
              <div
                v-for="(item, index) in itemData"
                :key="item.id"
                class="item-box"
                :class="[item.checked ? 'item-box-true' : '']"
                @click="draftChecked(index)"
                style="cursor: pointer; font-size: 13px"
              >
                <div
                  v-if="gzhShowData.length > 0"
                  style="position: absolute; top: 8px; right: 10px"
                >
                  <!-- <a-checkbox :checked="item.checked" @change="draftChecked($event,index)"></a-checkbox> -->
                  <a-icon
                    v-if="!item.checked"
                    @click.stop="draftChecked(index)"
                    style="font-size: 26px; color: #dbdbdb"
                    type="check-circle"
                    theme="filled"
                  />
                  <a-icon
                    v-else
                    @click.stop="draftChecked(index)"
                    style="font-size: 26px; color: #1890ff"
                    type="check-circle"
                    theme="filled"
                  />
                </div>

                <div
                  class="item-box-title"
                  style="display: flex; justify-content: space-between"
                >
                  <span> 公众号：{{ item.gzh_name }}</span>
                  <a-tag
                    color="blue"
                    style="text-align: center; padding: 0 12px"
                  >
                    {{ type_map[item.draft_type] || "H5" }}
                  </a-tag>
                </div>
                <div class="item-box-title">
                  最近修改：{{ item.update_time }}
                </div>
                <div style="position: relative">
                  <a-popover v-if="item.content[0].url" placement="right">
                    <template slot="content">
                      <span
                        @click.stop="PCpreview(item.content[0])"
                        style="cursor: pointer"
                        >本地预览</span
                      >
                    </template>
                    <div>
                      <img
                        class="item-top-img"
                        style=""
                        :src="
                          item.content[0].local_thumb_url +
                          (item.content[0].local_thumb_url.indexOf('?') > -1
                            ? ''
                            : '?x-oss-process=image/resize,h_150,m_lfit')
                        "
                        alt=""
                      />
                      <div class="item-top-title" style="">
                        {{ item.content[0].title || "空" }}
                      </div>
                    </div>
                  </a-popover>
                  <div v-else>
                    <img
                      class="item-top-img"
                      style=""
                      :src="
                        item.content[0].local_thumb_url +
                        (item.content[0].local_thumb_url.indexOf('?') > -1
                          ? ''
                          : '?x-oss-process=image/resize,h_150,m_lfit')
                      "
                      alt=""
                    />
                    <div class="item-top-title" style="">
                      {{ item.content[0].title || "空" }}
                    </div>
                  </div>
                </div>

                <div v-for="(item_z, index_z) in item.content" :key="index_z">
                  <a-popover v-if="index_z > 0 && item_z.url" placement="right">
                    <template slot="content">
                      <span
                        @click.stop="PCpreview(item_z)"
                        style="cursor: pointer"
                        >本地预览</span
                      >
                    </template>
                    <div class="item-cell-box">
                      <div style="flex: 1">{{ item_z.title }}</div>
                      <img
                        class="item-cell-img"
                        :src="
                          item_z.local_thumb_url +
                          (item_z.local_thumb_url.indexOf('?') > -1
                            ? ''
                            : '?x-oss-process=image/resize,h_100,m_lfit')
                        "
                        alt=""
                      />
                    </div>
                  </a-popover>
                  <div v-else-if="index_z > 0" class="item-cell-box">
                    <div style="flex: 1">{{ item_z.title }}</div>
                    <img
                      class="item-cell-img"
                      :src="
                        item_z.local_thumb_url +
                        (item_z.local_thumb_url.indexOf('?') > -1
                          ? ''
                          : '?x-oss-process=image/resize,h_100,m_lfit')
                      "
                      alt=""
                    />
                  </div>
                </div>

                <div class="item-button-box" style="">
                  <div
                    @click.stop="handleButton(2, item)"
                    class="handle-button"
                    style="margin-right: 20px; margin-bottom: 7px"
                  >
                    手机预览
                  </div>
                  <div
                    @click.stop="handleButton(3, item)"
                    class="handle-button"
                    style="margin-right: 20px; margin-bottom: 7px"
                  >
                    删 除
                  </div>
                  <div
                    @click.stop="handleButton(4, item)"
                    class="handle-button"
                    style="margin-right: 20px; margin-bottom: 7px"
                  >
                    群 发
                  </div>
                  <!-- <div @click.stop="handleButton(6,item)" class="handle-button" style="margin-right: 20px;margin-bottom: 7px;">编 辑</div> -->
                  <div
                    @click.stop="handleButton(7, item)"
                    class="handle-button"
                    style="margin-right: 20px; margin-bottom: 7px"
                  >
                    复 制
                  </div>
                </div>
              </div>
            </div>

            <div
              v-show="itemData.length == 0"
              style="
                text-align: center;
                text-align: center;
                padding: 80px 0 50px;
              "
            >
              <a-icon style="font-size: 70px; color: #999" type="file-search" />
              <div
                v-if="title_gzh_name"
                style="color: #999; font-size: 16px; margin-top: 20px"
              >
                内容为空
              </div>
              <div
                v-else
                style="color: #999; font-size: 16px; margin-top: 20px"
              >
                请选择公众号
              </div>
            </div>
          </div>

          <!-- 发表记录 -->
          <div v-else-if="page_type == 2">
            <!-- 分页 -->
            <div
              style="margin-bottom: 30px; display: flex; align-items: center"
            >
              <a-pagination
                size="small"
                v-model="r_page"
                :pageSize="r_limit"
                :total="table_total"
                :showTotal="(total, range) => `共 ${total} 条`"
                @change="paginationChange"
                show-quick-jumper
              />

              <div
                v-show="gzhShowData.length > 0"
                @click="selectRecordAll(1)"
                style="margin: 0 20px; color: #62a8ea; cursor: pointer"
              >
                全选
              </div>
              <div
                v-show="gzhShowData.length > 0"
                @click="selectRecordAll(2)"
                style="margin-right: 20px; color: #62a8ea; cursor: pointer"
              >
                取消全选
              </div>
            </div>

            <div
              v-for="(item, index) in recordData"
              :key="item.id"
              class="item-box"
              :class="[item.checked ? 'item-box-true' : '']"
              @click.stop="checkboxChange(index)"
              style="cursor: pointer; font-size: 13px"
            >
              <div
                v-if="gzhShowData.length > 0"
                style="position: absolute; top: 8px; right: 10px"
              >
                <a-icon
                  v-if="!item.checked"
                  @click.stop="checkboxChange(index)"
                  style="font-size: 26px; color: #dbdbdb"
                  type="check-circle"
                  theme="filled"
                />
                <a-icon
                  v-else
                  @click.stop="checkboxChange(index)"
                  style="font-size: 26px; color: #1890ff"
                  type="check-circle"
                  theme="filled"
                />
              </div>

              <div
                class="item-box-title"
                style="display: flex; justify-content: space-between"
              >
                <span> 公众号：{{ item.gzh_name }}</span>
                <a-tag color="blue" style="text-align: center; padding: 0 12px">
                  {{ type_map[item.draft_type] || "H5" }}
                </a-tag>
              </div>
              <div
                v-if="item.send_log && item.send_log.status == 1"
                class="item-box-title"
              >
                已发送：{{ item.send_log.server_send_time }}
              </div>
              <div
                v-else-if="item.send_log && item.send_log.status == 0"
                class="item-box-title"
                style="display: flex; justify-content: space-between"
              >
                定时中：{{ item.send_log.send_time | clickDate }}
                <div
                  @click.stop="recordCancel(item)"
                  style="flex-shrink: 0; color: #62a8ea; cursor: pointer"
                >
                  取消
                </div>
              </div>
              <div v-else class="item-box-title">
                发布时间：{{ item.update_time }}
              </div>

              <div
                v-if="item.send_log && item.send_log.tag_name"
                class="item-box-title"
              >
                标签：
                <a-tag color="cyan">{{ item.send_log.tag_name }}</a-tag>
              </div>
              <div v-else class="item-box-title">
                <a-tag color="cyan">全部用户</a-tag>
              </div>

              <div
                v-if="
                  item.content[0].del_control &&
                  item.send_log &&
                  item.send_log.status == 1
                "
                style="position: relative"
              >
                <img
                  class="item-top-img"
                  style=""
                  :src="item.content[0].local_thumb_url"
                  alt=""
                />
                <div class="item-top-title" style="">
                  {{ item.content[0].title }}
                  <a-tag v-if="item.content[0].del_control" color="red"
                    >已删除</a-tag
                  >
                </div>
              </div>
              <a-popover v-else placement="right">
                <template slot="content">
                  <div
                    @click.stop="delMessageCell(item.content[0], item, 0)"
                    style="cursor: pointer"
                  >
                    删除
                  </div>
                </template>
                <div style="position: relative">
                  <img
                    class="item-top-img"
                    style=""
                    :src="item.content[0].local_thumb_url"
                    alt=""
                  />
                  <div class="item-top-title" style="">
                    {{ item.content[0].title }}
                  </div>
                </div>
              </a-popover>

              <div v-for="(item_z, index_z) in item.content" :key="index_z">
                <div
                  v-if="
                    index_z > 0 &&
                    item_z.del_control &&
                    item.send_log &&
                    item.send_log.status == 1
                  "
                  class="item-cell-box"
                >
                  <div style="flex: 1">
                    {{ item_z.title }}
                    <a-tag v-if="item_z.title" color="red">已删除</a-tag>
                  </div>
                  <img
                    class="item-cell-img"
                    :src="item_z.local_thumb_url"
                    alt=""
                  />
                </div>

                <a-popover v-else-if="index_z > 0" placement="right">
                  <template slot="content">
                    <div
                      @click.stop="delMessageCell(item_z, item, index_z)"
                      style="cursor: pointer"
                    >
                      删除
                    </div>
                  </template>
                  <div v-if="index_z > 0" class="item-cell-box">
                    <div style="flex: 1">{{ item_z.title }}</div>
                    <img
                      class="item-cell-img"
                      :src="item_z.local_thumb_url"
                      alt=""
                    />
                  </div>
                </a-popover>
              </div>

              <div class="item-button-box" style="">
                <div
                  @click.stop="handleButton(5, item)"
                  class="handle-button"
                  style="margin-right: 20px; margin-bottom: 7px"
                >
                  从历史记录删除
                </div>

                <div
                  @click.stop="handleButton(8, item)"
                  class="handle-button"
                  style="margin-right: 20px; margin-bottom: 7px"
                >
                  创建草稿
                </div>
              </div>
            </div>
            <div
              v-show="recordData.length == 0"
              style="
                text-align: center;
                text-align: center;
                padding: 80px 0 50px;
              "
            >
              <a-icon style="font-size: 70px; color: #999" type="file-search" />
              <div style="color: #999; font-size: 16px; margin-top: 20px">
                内容为空
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      title="群发消息"
      :visible="message_visible"
      :confirm-loading="message_confirmLoading"
      @ok="messageHandleOk"
      @cancel="messageHandleCancel"
      width="1100px"
    >
      <div>
        <div
          style="margin-bottom: 15px; margin-left: 20px; color: #e85a32"
          v-if="draftSelected.length > 0"
        >
          提示：有 {{ gzh_select_num }} 个公众号选择了多个草稿，有
          {{ gzh_no_select_num }}
          个公众号未选择草稿，这些公众号会在新建定时任务时被忽略。
        </div>

        <div
          v-if="pl_send_control == 2"
          class="form-cell-box"
          style="align-items: flex-start"
        >
          <div class="class-title">已选草稿：</div>
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              max-height: 200px;
              overflow-y: overlay;
            "
          >
            <div
              v-for="(item, index) in draftSelected"
              :key="index"
              style="margin-right: 7px"
            >
              {{ item.gzh_name }}（草稿ID：{{ item.id }}）
            </div>
          </div>
        </div>

        <div class="form-cell-box">
          <div class="class-title">群发类型</div>
          <div>
            <a-radio-group
              @change="messTypeA"
              name="radioGroup"
              :value="s_send_time_type"
            >
              <a-radio :value="2"> 定时群发 </a-radio>
              <a-radio :value="1"> 立刻群发 </a-radio>
            </a-radio-group>
          </div>
        </div>

        <div v-if="s_send_time_type == 2" class="form-cell-box">
          <div class="class-title">发送时间</div>

          <a-date-picker
            show-time
            style="width: 340px"
            @change="onSendChange"
            :allowClear="false"
            placeholder="选择发送时间"
            :disabledDate="disabledDate"
          />
        </div>

        <div v-if="pl_send_control == 1" class="form-cell-box">
          <div class="class-title">人群</div>
          <div>
            <a-radio-group
              @change="messTypeB"
              name="radioGroup"
              :value="s_send_type"
            >
              <a-radio :value="1"> 全部用户 </a-radio>
              <a-radio :value="2"> 按标签选择 </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div v-if="pl_send_control == 2" class="form-cell-box">
          <div class="class-title">人群</div>
          <div>
            <a-radio-group
              @change="messTypeB"
              name="radioGroup"
              :value="s_send_type"
            >
              <a-radio :value="1"> 全部用户 </a-radio>
            </a-radio-group>
          </div>
        </div>

        <div v-if="s_send_type == 2" class="form-cell-box">
          <div class="class-title">标签</div>

          <a-select
            style="width: 340px"
            placeholder="未选择"
            :filter-option="filterOption"
            @change="handleChangeH"
            showSearch
          >
            <a-select-option
              v-for="(item, index) in sendTagData"
              :key="index"
              :value="item.tag_id"
            >
              {{ item.tag_name }}（ {{ item.tag_count }} ）
            </a-select-option>
          </a-select>
        </div>

        <div v-if="s_send_type == 1" class="form-cell-box">
          <div class="class-title"></div>
          <a-checkbox :checked="aaaaa" @change="onTagChange">
            <span v-if="pl_send_control == 2" style="user-select: none"
              >通过标签 星标组群发，新用户看不到历史文章</span
            >
            <span v-else style="user-select: none"
              >通过标签 星标组（{{
                gzhTagObj.tag_count || 0
              }}）群发，新用户看不到历史文章</span
            >
          </a-checkbox>
        </div>

        <div class="form-cell-box" style="align-items: flex-start">
          <div class="class-title">说明</div>
          <div style="color: #e85a32">
            <div style="margin-bottom: 5px">
              1.选择多个公众号时，系统会自动将发送时间依次延迟2-5分钟。
            </div>
            <div>
              2.对于 星标组 人数低于总人数60%的公众号，会自动改为全部用户群发。
            </div>
            <div>
              3.创建群发任务时，基于人群选择、公众号模式和草稿类型确定最终发送用户。
              <p class="text_p">
                ⅰ公众号模式和草稿类型一致（均为H5或均为小程序时），按照所选人群发送。
              </p>
              <p class="text_p">
                ⅱ公众号模式为H5+小程序，草稿类型为H5时，不论是否勾选星标组，均发送给H5老用户标签。
              </p>
              <p class="text_p">
                ⅲ公众号模式为H5+小程序，草稿类型为小程序时，不论是否勾选星标组，均发送给小程序新用户标签。
              </p>
              <p class="text_p">ⅳ其它情况，忽略，不群发。</p>
              <p class="text_p" v-if="draftSelected.length === 0">
                人群选择 按标签选择 时：除星标组外，均按照实际选择标签发送。
              </p>
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <a-modal
      title="预览"
      :visible="preview_visible"
      :confirm-loading="preview_confirmLoading"
      @ok="previewOk"
      @cancel="previewCancel"
      width="700px"
    >
      <div>
        <div class="form-cell-box">
          <div class="class-title">微信号</div>
          <a-input
            v-model="s_wechat_id"
            placeholder="请输入微信号"
            style="width: 330px"
          />
        </div>
        <div class="form-cell-box">
          <div class="class-title"></div>
          <div>提示：该微信需要首先关注公众号：{{ preview_gzh_name }}</div>
        </div>
        <div class="form-cell-box">
          <div class="class-title"></div>
          <img
            v-if="preview_code_url"
            :src="preview_code_url"
            style="width: 180px; vertical-align: text-top"
          />
        </div>
      </div>
    </a-modal>

    <a-modal
      title="批量删除的报错信息"
      :visible="del_msg_modal"
      @ok="del_msg_modal = false"
      @cancel="del_msg_modal = false"
      width="600px"
    >
      <div style="max-height: 300px; overflow: overlay">
        <div
          v-for="(item, index) in delErrMsg"
          :key="index"
          style="margin-bottom: 5px"
        >
          <span>id: {{ item.id }}</span> - <span>{{ item.msg }}</span>
        </div>
      </div>
    </a-modal>

    <a-modal
      title="批量群发的报错信息"
      :visible="draft_msg_modal"
      @ok="draft_msg_modal = false"
      @cancel="draft_msg_modal = false"
      width="600px"
    >
      <div style="max-height: 300px; overflow: overlay">
        <div
          v-for="(item, index) in draftErrMsg"
          :key="index"
          style="margin-bottom: 5px"
        >
          <span>id: {{ item.id }}</span> - <span>{{ item.msg }}</span>
        </div>
      </div>
    </a-modal>

    <!-- 发表记录-已选删除记录 -->
    <a-modal
      title="删除记录"
      :visible="record_visible"
      :confirm-loading="record_confirmLoading"
      @ok="recordOk"
      @cancel="recordModalCancel"
      width="1100px"
      okText="删除"
      okType="danger"
    >
      <div>
        <div class="form-cell-box" style="align-items: flex-start">
          <div class="class-title">已选记录：</div>
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              max-height: 450px;
              overflow-y: overlay;
            "
          >
            <div
              v-for="(item, index) in selectedData"
              :key="index"
              style="margin-right: 7px; margin-bottom: 3px"
            >
              {{ item.gzh_name }}（记录ID：{{ item.id }}）
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- 微信草稿箱-已选删除记录 -->
    <a-modal
      title="批量删除草稿"
      :visible="del_draft_visible"
      :confirm-loading="del_draft_loading"
      @ok="delDraftOk"
      @cancel="delDraftCancel"
      width="1100px"
      okText="删除"
      okType="danger"
    >
      <div>
        <div
          class="form-cell-box"
          style="align-items: flex-start; margin-bottom: 0"
        >
          <div class="class-title">已选草稿：</div>
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              max-height: 500px;
              overflow-y: overlay;
            "
          >
            <div
              v-for="(item, index) in draftSelected"
              :key="index"
              style="margin-right: 10px; margin-bottom: 3px"
            >
              {{ item.gzh_name }}（草稿ID：{{ item.id }}）
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- 发表记录 - 复制图文到自己所属公众号 -->
    <a-modal
      title="复制图文到自己所属公众号"
      :visible="copy_self_visible"
      :confirm-loading="copy_self_loading"
      @ok="copySelfOk"
      @cancel="copySelfCancel"
      width="1100px"
    >
      <div>
        <div
          class="form-cell-box"
          style="align-items: flex-start; margin-bottom: 0"
        >
          <div class="class-title">已选记录：</div>
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              max-height: 500px;
              overflow-y: overlay;
            "
          >
            <div
              v-for="(item, index) in selectedData"
              :key="index"
              style="margin-right: 10px; margin-bottom: 3px"
            >
              {{ item.gzh_name }}（草稿ID：{{ item.id }}）
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- 复制草稿到其他公众号弹窗 -->
    <copyDraftsModal
      ref="getCopyDrafts"
      @modal-ok="copyModalOk"
      @false-laoding="copyFalseLaoding"
    ></copyDraftsModal>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";

import copyDraftsModal from "@/views/Operate/operMessage/components/copyDraftsModal.vue";

import {
  wxMaterialDraft,
  wxMaterialPreview,
  wxMaterialDel,
  wxMaterialSend,
  wxMaterialTag,
  wxMaterialDraftSync,
  wxGetGzhCode,
  massSendTaskCancel,
  massSendTaskDel,
  massSendCellDel,
  wxMaterialBatchSend,
  getChannelGzh,
  wxPlGzhTagFans,
  wxCopySelf,
} from "@/request/api";
export default {
  name: "wxMaterialDrafts_",
  components: {
    copyDraftsModal,
  },
  data() {
    return {
      // 1=H5、2=小程序、0=未知
      type_map: {
        1: `H5`,
        2: `小程序`,
        0: `未知`,
      },
      locale,
      moment,

      search_button_loading: false,

      r_page: 1, // 页数
      r_limit: 20, // 每页多少条
      table_total: 0, // 总数

      itemData: [],
      recordData: [],

      r_name: null,
      r_channel_id: null, // 渠道/书城

      selectData: {}, // 下拉

      content_height: 600, // 内容盒子的高度
      left_book_height: 300, // 左边书城列表的高度

      // 群发消息弹窗
      message_visible: false,
      message_confirmLoading: false,

      current: ["mail"],
      openKeys: ["sub1"],

      sync_true: false, // 刷新的icon是否旋转
      sync_true_control: true, // 刷新的节流控制

      menuData: [], // 左侧渠道数据

      r_gzh_id: undefined, // 公众号id

      s_id: null, // 列表ID，用于群发消息
      s_send_type: 2, // 发送类型：1=全部，2=按标签id
      s_send_time_type: 2, // 发送时间类型，1=立即发送，2=定时发送
      s_tag_id: undefined, // send_type=2 必传标签id
      s_send_time: undefined, // send_time_type=2必传时间
      sendTagData: [], // 标签

      // 预览弹窗
      preview_visible: false,
      preview_confirmLoading: false,
      s_wechat_id: "", // 微信号
      preview_gzh_name: "",

      title_gzh_name: "全部", // 选中的公众号名字

      page_type: 1, // 页面类型，1为草稿箱。2为发表记录

      // 发表记录相关的数据
      publishData: [],
      p_page: 1,
      p_table_total: 0,
      r_is_send: 0, // 0表示微信草稿箱的列表，1表示已发布的草稿箱列表

      preview_code_url: "", // 预览弹窗要展示的 公众号二维码

      // 多选
      selectedData: [], // 发表记录选中的数据
      draftSelected: [], // 草稿箱选中的数据
      // {id: '景中书卷', msg: '删除失败'},{id: '景中书卷', msg: '删除失败'}
      delErrMsg: [], // 发表记录-批量删除后，返回的错误存放数组
      del_msg_modal: false,

      draftErrMsg: [], // 草稿箱-批量群发后，返回的错误存放数组
      draft_msg_modal: false,

      aaaaa: true,
      gzhTagObj: {}, // 获取星标组tag的相关数据

      all_style_status: true, // 全部公众号控制
      all_select_control: true, // 全部选项的控制，true为显示

      pl_send_control: 1, // 1是单个群发，2是批量群发

      tabData: [
        { label: "草稿箱", key: 1, status: true },
        { label: "发表记录", key: 2, status: false },
      ],
      nav_select_control: false, // 左侧边栏的多选框是否显示控制
      gzhSelectData: [], // 选中的公众号
      gzhShowData: [], // 加载回来的用于展示
      gzh_select_visible: false,
      gzh_no_select_num: 0,
      gzh_select_num: 0,

      single_gzh: {}, // 已选公众号下的单选某个公众号
      record_visible: false, // 删除记录弹窗
      record_confirmLoading: false,

      // 批量删除草稿
      del_draft_visible: false,
      del_draft_loading: false,

      // 复制图文到自己所属公众号
      copy_self_visible: false,
      copy_self_loading: false,

      // 批量取消已选公众号
      pl_cancel_gzh: false,
    };
  },
  mounted() {
    let that = this;

    console.log("document.body.clientHeight", document.body.clientHeight);
    that.content_height = document.body.clientHeight - 65 - 15 * 2;

    that.left_book_height = that.content_height - 13 - 42 - 28;
    console.log("that.left_book_height", that.left_book_height);

    // 修改母页面的tab高亮状态
    setTimeout(() => {
      that.$bus.$emit("tabPath", that.$route.fullPath);
    }, 300);

    // 获取 左侧渠道>公众号
    that.onSearchGzh(null);
  },
  watch: {
    openKeys(val) {
      console.log("openKeys", val);
    },
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeH(e) {
      this.s_tag_id = e;
    },
    onSearchGzh(e, type) {
      console.log("公众号搜索", e);
      let that = this;
      that.search_button_loading = true;
      // 获取渠道公众号。渠道以及渠道下的公众号接口（wxMaterialAllSelect）
      // wxMaterialAllSelect({ // 获取左侧下拉
      // 	gzh_name: e
      // }).then(res=>{
      // 	console.log("获取所有下拉",res.data.data.list);
      // 	that.search_button_loading = false
      // 	if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){

      // 		let data = res.data.data.list
      // 		let mData = []
      // 		for (let key in data) {
      // 			let ooo = {}
      // 			if(e){ // 如果是带内容搜索的，就要都展开
      // 				that.all_select_control = false

      // 				ooo.key = key
      // 				ooo.select_status = true, // 控制是否展开
      // 				ooo.style_status = false // 用于控制样式的
      // 			}
      // 			else {
      // 				that.all_select_control = true

      // 				ooo.key = key
      // 				ooo.select_status = false, // 控制是否展开
      // 				ooo.style_status = false // 用于控制样式的
      // 			}

      // 			let ccc = data[key]
      // 			ccc.forEach(res=>{
      // 				res.click_status = false
      // 			})
      // 			ooo.value = ccc
      // 			mData.push(ooo)
      // 		}
      // 		console.log("mData",mData);
      // 		that.menuData = mData

      // 		if(type != 'search_button'){
      // 			that.r_gzh_id = undefined
      // 			that.searchButton()
      // 		}

      // 	}
      // 	else {
      // 		that.search_button_loading = false
      // 		if(res.data.code == 401){ // 未登录
      // 			localStorage.removeItem("access_token");
      // 			that.$router.replace({name: 'login',params: {type:'not_log'}})
      // 		}
      // 		else {
      // 			that.$message.error(`错误：${res.data.msg}`);
      // 		}
      // 	}
      // })

      // 获取渠道、分组、公众号
      getChannelGzh({
        gzh_name: e,
      }).then((res) => {
        console.log("公众号分组", res);
        that.search_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          let data = res.data.data.list;
          let m_data = [];
          for (let key in data) {
            let obj = {
              // key: null,
              // select_loading: 0,
              name: key,
              select_status: false,
              style_status: false,
              check_status: false,
              check_indeterminate: false,
              value: [],
            };
            let z_arr = [];
            for (let z_ey in data[key]) {
              let z_bj = {
                name: z_ey,
                status: false,
                check_status: false,
                check_indeterminate: false,
                value: [],
              };
              data[key][z_ey].forEach((re_z) => {
                re_z.click_status = false;
                re_z.check_status = false;
              });
              z_bj.value = data[key][z_ey];
              z_arr.push(z_bj);
            }

            obj.value = z_arr;
            m_data.push(obj);
          }
          console.log("m_data", m_data);
          that.menuData = m_data;

          if (type != "search_button") {
            that.r_gzh_id = undefined;
            that.searchButton();
          }
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    // 点击公众号
    handleClickGzh(e) {
      console.log("click", e);
      let that = this;
      this.search_button_loading = true;
      this.r_gzh_id = e.key;

      this.searchButton();
      wxMaterialTag({
        gzh_id: this.r_gzh_id,
      }).then((res) => {
        console.log("获取标签", res);
        that.sendTagData = res.data.data.data;
      });
    },
    titleClick(e, value) {
      let that = this;
    },
    searchButton(type, g_id) {
      let that = this;
      that.search_button_loading = true;

      let r_data = {
        page: that.r_page, // 页数
        limit: that.r_limit, // 每页多少条
        gzh_id: that.r_gzh_id, // 公众号ID
        is_send: that.r_is_send, // 0表示微信草稿箱的列表，1表示已发布的草稿箱列表
      };
      if (type == "refresh") {
        that.r_page = 1;
      }
      if (type == "refresh" || type == "分页") {
        let i_data = [];
        that.gzhShowData.forEach((res) => {
          i_data.push(res.id);
        });

        r_data.page = that.r_page;
        r_data.gzh_id = i_data;
      }
      if (type == "single") {
        // 单选某一个
        that.r_page = 1;
        r_data.page = that.r_page;
        r_data.gzh_id = g_id;
      }
      console.log(r_data, `12312313312`);
      wxMaterialDraft(r_data)
        .then((res) => {
          that.search_button_loading = false;
          if (type == "refresh") {
            that.sync_true = false;
          }
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            if (that.page_type == 1) {
              let data = res.data.data.data;
              data.forEach((res) => {
                res.checked = false;
              });

              if (type == "全部") {
                that.draftSelected = [];
                that.gzhShowData = [];
              }

              if (type != "全部") {
                data.forEach((res) => {
                  that.draftSelected.forEach((re_z) => {
                    if (res.id == re_z.id) {
                      res.checked = true;
                    }
                  });
                });
                that.itemData = data;

                // 计算已选择公众号的已选草稿数量，未选草稿数量
                that.computedSelectDraft();
              }
            } else if (that.page_type == 2) {
              // 发表记录
              let data = res.data.data.data;
              data.forEach((res) => {
                res.checked = false;
              });
              that.recordData = res.data.data.data;
              that.selectedData = [];

              data.forEach((res) => {
                res.content.forEach((re_a) => {
                  re_a.del_control = false;
                });
              });
              data.forEach((res) => {
                // 给已删除的单个素材加上标记
                // 这里会出现Warning: [antdv: Checkbox] `value` is not validate prop, do you mean `checked`的报错，解决办法就是把下面这个循环拆出去
                if (res.delete_article_idx) {
                  res.delete_article_idx.forEach((res_z, index_z) => {
                    res.content[res_z.article_idx - 1].del_control = true;
                  });
                }
              });
              that.recordData = res.data.data.data;
            }
            that.table_total = res.data.data.total;
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        })
        .catch((err) => {
          // console.log("err",err);
          that.search_button_loading = false;
          that.$message.error(`错误：${err}`);
        });
    },
    // 刷新
    RefreshButton() {
      this.sync_true = true;
      this.searchButton("refresh");
    },
    goAdd() {
      this.$router.push({ path: "/materialAdd" });
    },
    // 切换书城列表
    changeMenu(e, index) {
      // console.log("切换书城列表",e);
      e.select_status = !e.select_status;
    },
    // 切换分组
    changeMenuB(ite_z) {
      // console.log("ite_z",ite_z);
      ite_z.status = !ite_z.status;
    },
    // 切换公众号
    menuSecond(item_z, index_z, item) {
      let that = this;

      if (that.nav_select_control) {
        return;
      }

      function handleFun() {
        item.style_status = true;

        console.log("item_z", item_z);
        that.title_gzh_name = item_z.gzh_name;

        that.menuData.forEach((res) => {
          res.style_status = false;

          res.value.forEach((res_z) => {
            res_z.value.forEach((re_g) => {
              re_g.click_status = false;
            });
          });
        });
        item.style_status = true;
        item_z.click_status = !item_z.click_status;

        that.all_style_status = false; // 取消全部的高亮状态
        that.r_gzh_id = item_z.id;

        that.plSelectConfirm("单选公众号", item_z.id);
      }

      if (that.gzhShowData.length > 1) {
        // 有两个及以上就提示
        this.$confirm({
          title: "提示",
          content: (h) => <div>批量选择的公众号会被替换，是否继续?</div>,
          onOk() {
            handleFun();
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      } else {
        handleFun();
      }
      // this.searchButton()
    },
    // 切换书城列表-全部
    changeAllMenu() {
      if (this.nav_select_control) {
        return;
      }

      this.all_style_status = true;

      this.menuData.forEach((res) => {
        res.style_status = false;

        res.value.forEach((res_z) => {
          res_z.click_status = false;
        });
      });

      this.title_gzh_name = "全部";
      this.r_gzh_id = undefined;
      this.searchButton("全部");
    },
    paginationChange(e) {
      this.r_page = e;
      this.searchButton("分页");
    },
    onShowSizeChange(current, pageSize) {
      console.log("每页多少条", pageSize);
      this.r_limit = pageSize;
      this.searchButton("refresh");
    },

    // 操作按钮
    handleButton(e, item) {
      let that = this;
      if (e == 1) {
        // 编辑
      } else if (e == 2) {
        // 预览
        this.s_id = item.id;
        this.preview_gzh_name = item.gzh_name;
        this.search_button_loading = true;
        wxGetGzhCode({
          id: item.gzh_id,
        }).then((res) => {
          that.search_button_loading = false;
          that.preview_code_url = res.data.data.info.qr_code || "";
          that.preview_visible = true;
        });
      } else if (e == 3) {
        // 删除
        this.$confirm({
          title: "确定要删除吗?",
          content: `id：${item.id}`,
          okText: "删除",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            wxMaterialDel({
              id: item.id,
            }).then((res) => {
              if (res.data.code == 0) {
                that.$message.success("删除成功");
                that.searchButton();
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            });
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      } else if (e == 4) {
        // 群发
        this.search_button_loading = true;
        wxMaterialTag({
          gzh_id: item.gzh_id,
        }).then((res) => {
          // console.log("获取标签", res);
          this.search_button_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.sendTagData = res.data.data.data;
            let data = res.data.data.data;
            data.forEach((res) => {
              if (res.tag_name.indexOf("星标") > -1) {
                that.gzhTagObj = res;
                // console.log("星标", that.gzhTagObj);
              }
            });
            that.s_id = item.id;
            that.message_visible = true;
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      } else if (e == 5) {
        // 发表记录 的 从历史记录删除 按钮
        that.search_button_loading = true;
        massSendCellDel({
          id: item.id,
          article_idx: 0,
        }).then((res) => {
          console.log(res);
          that.search_button_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.$message.success("删除成功");
            that.searchButton();
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      } else if (e == 6) {
        // 编辑草稿
        const { href } = this.$router.resolve({
          path: "/wxDraftsEdit",
          query: { edit_id: item.id },
        });
        window.open(href, "_blank");
      } else if (e == 7) {
        // 复制
        that.search_button_loading = true;
        that.$refs.getCopyDrafts.showModal(item.id);
      } else if (e == 8) {
        // 发表记录-复制到本公众号

        that.$confirm({
          title: "确定要 复制该图文到自己所属公众号 吗?",
          content: `草稿ID：${item.id}`,
          onOk() {
            console.log("OK");
            let i_data = [];
            i_data.push(item.id);
            wxCopySelf({
              draft_ids: i_data,
            }).then((res) => {
              console.log("复制图文到自己所属公众号", res);
              that.copy_self_loading = false;
              if (
                res.data.code == 0 ||
                res.data.code == 200 ||
                res.data.code == 8011
              ) {
                // that.$message.success('复制成功');
                // that.copySelfCancel()
                // that.searchButton('refresh')
                that.handleConfirm(res.data.msg);
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            });
          },
          onCancel() {
            console.log("Cancel");
          },
          class: "test",
        });
      }
    },
    handleConfirm(msg) {
      let that = this;
      that.$confirm({
        title: msg,
        icon: "exclamation-circle",
        class: "jlzh", //类名
        okText: "查看进度",
        cancelText: "取消",
        content: (h) => <div>点击按钮前往-草稿箱新建记录</div>,
        onOk() {
          console.log("OK");

          const { href } = that.$router.resolve({
            path: "/syncWxRecord",
            query: { jump_type: "2" },
          });
          window.open(href, "_blank");
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },

    // 群发消息弹窗
    messageHandleOk() {
      let that = this;
      if (that.s_send_time_type == 2 && !that.s_send_time) {
        this.$message.warning("请选择发送时间");
      } else if (that.s_send_type == 2 && !that.s_tag_id) {
        this.$message.warning("请选择标签");
      } else {
        this.message_confirmLoading = true;
        let s_type = that.s_send_type;
        if (that.aaaaa && that.s_send_type == 1) {
          // 如果这里勾选了，等于是固定传-- 按标签选择-星标组
          s_type = 2;
          that.sendTagData.forEach((res) => {
            if (res.tag_name == "星标组") {
              that.s_tag_id = res.tag_id;
            }
          });
        }
        if (this.pl_send_control == 2) {
          // 表示批量群发
          let iii = [];
          that.draftSelected.forEach((res) => {
            iii.push(res.id);
          });
          wxMaterialBatchSend({
            // 批量请求
            ids: iii,
            send_type: s_type, // 发送类型：1=全部，2=按标签id
            send_time_type: that.s_send_time_type, // 发送时间类型，1=立即发送，2=定时发送
            send_time: that.s_send_time, // send_time_type= 2必传时间
          }).then((res) => {
            console.log("批量群发测试", res);
            that.message_confirmLoading = false;
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.message_visible = false;
              that.$message.success("批量群发成功");
              that.draftSelected = [];
              // 报错信息，返回的data里有内容的话就表示有报错信息，就进行显示
              that.draftErrMsg = res.data.data || [];
              console.log("draftErrMsg", res.data.data);
              if (that.draftErrMsg) {
                that.draft_msg_modal = true;
              }

              that.searchButton();
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        } else {
          // 单个群发
          // let arr =[]
          // arr.push(that.s_id)
          wxMaterialSend({
            id: that.s_id, // 列表id
            send_type: s_type, // 发送类型：1=全部，2=按标签id
            send_time_type: that.s_send_time_type, // 发送时间类型，1=立即发送，2=定时发送
            tag_id: that.s_tag_id, // 标签
            send_time: that.s_send_time, // send_time_type= 2必传时间
          }).then((res) => {
            that.message_confirmLoading = false;
            console.log("群发消息弹窗-确认", res);

            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.$message.success(res.data.msg);
              that.messageHandleCancel();
              that.searchButton();
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        }
      }
    },
    messageHandleCancel() {
      this.message_visible = false;
      // 这些参数恢复默认值 要写在关闭弹窗后面，不然的话用户会看到弹窗内容先变化了，弹窗再关闭
      this.s_tag_id = undefined;
      // this.s_send_time = undefined
      this.pl_send_control = 1;
    },
    // 切换群发类型
    messTypeA(e) {
      console.log("切换群发类型", e);
      this.s_send_time_type = e.target.value;
    },
    // 切换人群
    messTypeB(e) {
      console.log("切换人群", e);
      this.s_send_type = e.target.value;
    },
    // 发送时间
    onSendChange(date, dateString) {
      console.log(date, dateString);
      this.s_send_time = dateString;
    },
    disabledDate(current) {
      // 今天之前的日期不可选，不包括今天。也就是今天也可以选，今天以及今天以后的日期都可以选
      return current && current < moment().subtract(1, "days");
    },

    // 手动微信同步草稿箱
    syncWxDraft() {
      let that = this;
      console.log("gzhShowData", that.gzhShowData);
      if (that.gzhShowData.length == 0) {
        this.$message.warning("请先选择公众号");
      }
      // if(!this.r_gzh_id || this.title_gzh_name == '全部'){
      // 	this.$message.warning('请先选择公众号')
      // }
      else {
        let i_data = [];
        that.gzhShowData.forEach((res) => {
          i_data.push(res.id);
        });
        this.search_button_loading = true;
        wxMaterialDraftSync({
          id: i_data,
          // id: this.r_gzh_id
        }).then((res) => {
          that.search_button_loading = false;
          console.log("手动微信同步草稿箱", res);
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.$message.success(res.data.msg);
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      }
    },

    // 预览弹窗
    previewOk() {
      let that = this;
      that.preview_confirmLoading = true;
      wxMaterialPreview({
        id: this.s_id,
        wechat_id: this.s_wechat_id,
      }).then((res) => {
        console.log("预览弹窗", res);
        that.preview_confirmLoading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success(res.data.msg);
          that.previewCancel();
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    previewCancel() {
      this.s_wechat_id = "";
      this.preview_visible = false;
    },

    // 本地预览
    PCpreview(e) {
      // console.log(e);
      window.open(e.url, "_blank");
    },

    // 左侧公众号列表的显示隐藏
    handleShow(e) {
      // console.log("that.menuData",this.menuData);
      if (e == 1) {
        // 进行展开操作
        this.menuData.forEach((res) => {
          res.select_status = true;
        });
      } else if (e == 2) {
        // 收起
        this.menuData.forEach((res) => {
          res.select_status = false;
        });
      }
    },

    // tab切換
    tabChagen(e) {
      console.log(e);
      if (e.key == 1) {
        // 1草稿箱
        this.r_page = 1;
        this.r_is_send = 0;
      } else if (e.key == 2) {
        // 2发表记录
        this.r_page = 1;
        this.r_is_send = 1;
      }
      this.page_type = e.key; // 1草稿箱，2发表记录

      this.tabData.forEach((res) => {
        res.status = false;
      });
      e.status = true;

      if (e.key == 1) {
        this.single_gzh = {};
      }
      this.searchButton("refresh");
    },

    // 发表记录-取消
    recordCancel(item) {
      console.log(item);
      let that = this;
      massSendTaskCancel({
        id: item.send_log.id,
      }).then((res) => {
        console.log("取消操作", res);
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("操作成功");
          that.searchButton();
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },

    // 多选框
    checkboxChange(index) {
      let that = this;
      if (that.gzhShowData.length == 0) {
        return;
      }
      if (that.recordData[index].checked) {
        // 为选中状态，然后要改为未选中状态
        that.recordData[index].checked = false;

        let iii;
        that.selectedData.forEach((res, index_z) => {
          if (res.id == that.recordData[index].id) {
            iii = index_z;
          }
        });
        that.selectedData.splice(iii, 1);
      } else {
        // 未选中状态改为选中状态
        that.recordData[index].checked = true;
        if (that.selectedData.length === 0) {
          that.selectedData.push(that.recordData[index]);
        } else {
          // 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
          let ddd = true;
          for (let i = 0; i < that.selectedData.length; i++) {
            if (that.selectedData[i].id === that.recordData[index].id) {
              ddd = false;
              break;
            }
          }
          if (ddd) {
            that.selectedData.push(that.recordData[index]);
          }
        }
      }
      console.log("that.selectedData", that.selectedData);
    },

    // 删除发表记录
    delRecordHandle(type) {
      let that = this;
      if (type == 1) {
        // 删除
        if (that.selectedData.length == 0) {
          this.$message.warning("请先选择要删除的记录");
        } else {
          that.record_visible = true;
        }
      } else if (type == 2) {
        // 复制
        if (that.selectedData.length == 0) {
          this.$message.warning("请先选择记录");
        } else {
          this.copy_self_visible = true;
        }
      }
    },
    // 删除单篇素材
    delMessageCell(item_z, item, index_z) {
      console.log("item", item);
      // console.log("2222",item.delete_article_idx[index_z]);
      let that = this;
      that.search_button_loading = true;
      massSendCellDel({
        id: item.id,
        article_idx: index_z + 1, // 要删除第几篇素材
      }).then((res) => {
        console.log(res);
        that.search_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("操作成功");
          that.searchButton();
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },

    // 是否勾选通过标签星标组
    onTagChange(e) {
      console.log(e);
      this.aaaaa = e.target.checked;
    },
    // 微信草稿箱-批量群发的勾选
    draftChecked(index) {
      let that = this;
      if (that.gzhShowData.length == 0) {
        return;
      }
      console.log("index", index);
      if (that.itemData[index].checked) {
        // 为选中状态，然后要改为未选中状态
        that.itemData[index].checked = false;

        let iii;
        that.draftSelected.forEach((res, index_z) => {
          if (res.id == that.itemData[index].id) {
            iii = index_z;
          }
        });
        that.draftSelected.splice(iii, 1);
      } else {
        // 未选中状态改为选中状态
        that.itemData[index].checked = true;
        if (that.draftSelected.length === 0) {
          that.draftSelected.push(that.itemData[index]);
        } else {
          // 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
          let ddd = true;
          for (let i = 0; i < that.draftSelected.length; i++) {
            if (that.draftSelected[i].id === that.itemData[index].id) {
              ddd = false;
              break;
            }
          }
          if (ddd) {
            that.draftSelected.push(that.itemData[index]);
          }
        }
      }

      // 计算已选择公众号的已选草稿数量，未选草稿数量
      that.computedSelectDraft();
    },
    // 计算已选择公众号的已选草稿数量，未选择草稿数量
    computedSelectDraft() {
      let that = this;
      console.log("that.draftSelected", that.draftSelected);
      that.gzhShowData.forEach((res) => {
        let i = 0;
        that.draftSelected.forEach((re_z) => {
          if (re_z.gzh_id == res.id) {
            i = i + 1;
          }
        });
        res.selecte_num = i;
      });
      let _a_ = 0;
      let _b_ = 0;
      that.gzhShowData.forEach((res) => {
        if (res.selecte_num == 0) {
          _a_ = _a_ + 1;
        } else if (res.selecte_num > 1) {
          _b_ = _b_ + 1;
        }

        // 如果跟单选内容有出入，那就赋值到单选内容上
        if (
          res.id == that.single_gzh.id &&
          res.selecte_num != that.single_gzh.selecte_num
        ) {
          that.single_gzh = res;
        }
      });
      that.gzh_no_select_num = _a_; // 未选择草稿数量
      that.gzh_select_num = _b_; // 已选择草稿数量
    },
    // 批量群发
    draftSendHandle(type) {
      let that = this;
      if (type == 1) {
        // 批量群发
        if (that.draftSelected.length == 0) {
          this.$message.warning("请选择内容");
        } else {
          this.pl_send_control = 2;
          this.s_send_type = 1;
          that.message_visible = true;
        }
      } else if (type == 2) {
        // 批量删除
        if (that.draftSelected.length == 0) {
          this.$message.warning("请选择内容");
        } else {
          that.del_draft_visible = true;
        }
      }
    },

    // 勾选渠道
    checkA(e, item) {
      console.log("勾选渠道", e.target.checked);
      console.log("勾选渠道item", item);
      item.check_status = e.target.checked;
      if (e.target.checked) {
        item.check_indeterminate = false;
        item.value.forEach((res) => {
          res.check_status = true;
          res.value.forEach((re_z) => {
            re_z.check_status = true;
          });
        });
      } else {
        item.check_indeterminate = false;
        item.value.forEach((res) => {
          res.check_status = false;
          res.value.forEach((re_z) => {
            re_z.check_status = false;
          });
        });
      }
      // 校验检查
      this.checkStatus(item);
    },
    // 勾选分组
    checkB(e, ite_z, item) {
      console.log("ite_z", ite_z);
      ite_z.check_status = e.target.checked;
      if (e.target.checked) {
        ite_z.value.forEach((re_z) => {
          re_z.check_status = true;
        });
      } else {
        ite_z.value.forEach((re_z) => {
          re_z.check_status = false;
        });
      }
      // 校验检查
      this.checkStatus(item);
    },
    // 勾选公众号
    checkC(e, item_z, item) {
      console.log("item_z", item_z);
      // item_z.check_status = !item_z.check_status
      // 校验检查
      this.checkStatus(item);
    },
    // 校验全部勾选
    checkStatus() {
      let gzh = [];
      this.menuData.forEach((item) => {
        let f = 0;
        let d = 0;

        item.value.forEach((res) => {
          let i = 0;
          let for_i = 0;
          res.value.forEach((re_z) => {
            for_i++;
            if (re_z.check_status) {
              i++;
              gzh.push(re_z); // 把已选的公众号筛选出来
            }
          });

          if (for_i == res.value.length) {
            if (i == res.value.length) {
              // 全选
              res.check_status = true;
              res.check_indeterminate = false;
            } else if (i > 0 && i < res.value.length) {
              // 表示有选中的，但是没有全选
              res.check_status = false;
              res.check_indeterminate = true;
            } else if (i == 0) {
              // 表示一个都没有选中
              res.check_status = false;
              res.check_indeterminate = false;
            }
          }

          if (res.check_status) {
            f++;
          }
          if (res.check_indeterminate) {
            d++;
          }
        });

        if (f == item.value.length) {
          // 表示全选
          item.check_status = true;
          item.check_indeterminate = false;
        } else if (f > 0 && f < item.value.length) {
          item.check_status = false;
          item.check_indeterminate = true;
        } else if (d > 0) {
          item.check_status = false;
          item.check_indeterminate = true;
        } else if (d == 0) {
          item.check_status = false;
          item.check_indeterminate = false;
        }
      });

      this.gzhSelectData = gzh;
    },
    plSelectConfirm(type, g_id) {
      console.log("this.gzhSelectData", this.gzhSelectData);
      let that = this;
      this.nav_select_control = false;
      let i_data = [];
      if (type == "单选公众号") {
        i_data.push(g_id);
      } else {
        this.gzhSelectData.forEach((res) => {
          i_data.push(res.id);
        });
      }
      that.single_gzh = {};
      console.log("i_data", i_data);
      if (i_data.length > 0) {
        this.search_button_loading = true;
        wxPlGzhTagFans({ gzh_id: i_data }).then((res) => {
          that.search_button_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            console.log("完成选择", res.data.data.list);
            let data = res.data.data.list;
            data.forEach((res) => {
              res.selecte_num = 0;
              res.select_show = false; // 用于删除已选中的公众号
            });
            that.gzhShowData = res.data.data.list;

            // 取消侧边栏-全部的高亮状态
            that.all_style_status = false;

            // 加载选择的数据
            that.searchButton("refresh");
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        });
      } else {
        that.gzhShowData = [];
      }
    },

    singleGzh(item) {
      let that = this;
      console.log("item", item);
      if (that.page_type == 1) {
        that.single_gzh = item;
        that.searchButton("single", that.single_gzh.id);
      }
    },
    delSingleGzh() {
      this.single_gzh = {};
      this.searchButton("refresh");
    },
    // 全选当前页下的所有草稿
    selectDraftAll(type) {
      let that = this;
      console.log("that.itemData", that.itemData);
      if (type == 1) {
        // 全选
        that.itemData.forEach((res) => {
          if (!res.checked) {
            // 未选中的话就要进行选中
            res.checked = true;
            that.draftSelected.push(res);
          }
        });
        console.log("that.draftSelected", that.draftSelected);
      } else if (type == 2) {
        // 取消全选
        that.itemData.forEach((res) => {
          res.checked = false;

          let iii = -1;
          that.draftSelected.forEach((re_z, index_z) => {
            if (re_z.id == res.id) {
              iii = index_z;
            }
          });
          if (iii > -1) {
            that.draftSelected.splice(iii, 1);
          }
        });
        console.log("that.draftSelected", that.draftSelected);
      }
      // 计算已选择公众号的已选草稿数量，未选草稿数量
      that.computedSelectDraft();
    },

    recordOk() {
      let that = this;
      // that.search_button_loading = true
      that.record_confirmLoading = true;
      let arr = [];
      that.selectedData.forEach((res) => {
        arr.push(res.id);
      });
      console.log("arr", arr);
      massSendTaskDel({
        ids: arr,
      }).then((res) => {
        console.log("批量删除", res);
        that.record_confirmLoading = false;
        // that.search_button_loading = false
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("删除成功");
          that.selectedData = [];
          that.delErrMsg = res.data.data || [];
          if (that.delErrMsg) {
            that.del_msg_modal = true;
          }
          that.searchButton();
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    recordModalCancel() {
      this.record_confirmLoading = false;
      this.record_visible = false; // 删除记录弹窗
    },

    // 复制弹窗确认
    copyModalOk() {
      let that = this;
      that.searchButton();
    },
    copyFalseLaoding() {
      this.search_button_loading = false;
    },

    // 批量删除草稿箱-弹窗
    delDraftOk() {
      let that = this;
      let i_data = [];
      console.log("draftSelected", that.draftSelected);
      that.draftSelected.forEach((res) => {
        i_data.push(res.id);
      });
      console.log("i_data", i_data);
      that.del_draft_loading = true;
      wxMaterialDel({
        id: i_data,
      }).then((res) => {
        that.del_draft_loading = false;
        console.log("删除", res);
        if (res.data.code == 0) {
          that.$message.success(res.data.msg || "删除成功");
          that.delDraftCancel();
          that.draftSelected = [];
          that.searchButton("refresh");
        } else {
          that.$message.error(`错误：${res.data.msg}`);
        }
      });
    },
    delDraftCancel() {
      this.del_draft_visible = false;
      this.del_draft_loading = false;
    },

    // 发表记录的全选 和 取消全选
    selectRecordAll(type) {
      let that = this;
      if (type == 1) {
        // 全选
        that.recordData.forEach((res) => {
          if (!res.checked) {
            // 未选中的话就要进行选中
            res.checked = true;
            that.selectedData.push(res);
          }
        });
      } else if (type == 2) {
        // 取消全选
        that.recordData.forEach((res) => {
          res.checked = false;

          let iii = -1;
          that.selectedData.forEach((re_z, index_z) => {
            if (re_z.id == res.id) {
              iii = index_z;
            }
          });
          if (iii > -1) {
            that.selectedData.splice(iii, 1);
          }
        });
      }
    },

    // 复制图文到自己所属公众号
    copySelfOk() {
      let that = this;
      let i_data = [];
      that.selectedData;
      that.selectedData.forEach((res) => {
        i_data.push(res.id);
      });
      that.copy_self_loading = true;
      wxCopySelf({
        draft_ids: i_data,
      }).then((res) => {
        console.log("复制图文到自己所属公众号", res);
        that.copy_self_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          // that.$message.success('复制成功');
          that.copySelfCancel();
          that.searchButton("refresh"); // 这里要再加载一遍是为了把选中状态清除
          that.handleConfirm(res.data.msg);
        } else {
          that.$message.error(`错误：${res.data.msg}`);
        }
      });
    },
    copySelfCancel() {
      this.copy_self_visible = false;
      this.copy_self_loading = false;
    },

    // 批量取消已选公众号-确认按钮
    confirmSelectGzh() {
      let that = this;

      console.log("that.gzhShowData", that.gzhShowData);
      let arr = [];
      let un_arr = [];
      that.gzhShowData.forEach((res) => {
        if (res.select_show == false) {
          arr.push(res);
        } else {
          un_arr.push(res);
        }
      });
      console.log("arr", arr);
      console.log("un_arr", un_arr);
      if (arr.length == that.gzhShowData.length) {
        // that.$message.warning('请先勾选要进行取消选择的公众号')
        that.pl_cancel_gzh = false;
      } else {
        that.pl_cancel_gzh = false;

        that.gzhShowData = arr;

        that.searchButton("refresh");

        console.log("that.menuData", that.menuData);
        that.menuData.forEach((res) => {
          res.value.forEach((res_b) => {
            res_b.value.forEach((res_c) => {
              un_arr.forEach((res_z) => {
                if (res_c.id == res_z.id) {
                  res_c.check_status = false;
                }
              });
            });
          });
        });
        // 校验检查
        that.checkStatus();
      }
    },
    cancelSelectGzh() {
      let that = this;
      that.pl_cancel_gzh = false;
      that.gzhShowData.forEach((res) => {
        res.select_show = false;
      });
    },
    // 选择已选公众号
    selectPlGzh(item) {
      item.select_show = !item.select_show;
    },
  },
  filters: {
    clickDate(value) {
      let ttt = value;
      // console.log(value);
      //时间戳转化成时间格式
      function timeFormat(value) {
        //value是整数，否则要parseInt转换,不会出现少个0的情况
        //如果value是10位数的需要 value* 1000
        var time = new Date(value * 1000);
        // console.log('time',time);
        var year = time.getFullYear();
        // console.log('time',time);
        var month = time.getMonth() + 1;
        var date = time.getDate();
        var hours = time.getHours();
        var minutes = time.getMinutes();
        var seconds = time.getSeconds();
        // return year + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
        return (
          year +
          "-" +
          add0(month) +
          "-" +
          add0(date) +
          " " +
          add0(hours) +
          ":" +
          add0(minutes) +
          ":" +
          add0(seconds)
        );
      }
      function add0(m) {
        return m < 10 ? "0" + m : m;
      }
      // console.log(timeFormat(value));
      return timeFormat(value);
    },
  },
};
</script>

<style scoped>
.wx-mater-drafts {
  background-color: #f0f2f5;
  margin: -20px -30px -30px -20px;
  padding: 15px;
  min-height: calc(100vh - 65px);
}

.big-menu-box {
  position: sticky;
  top: 80px;
  /* border-right: 1px solid #e8e8e8; */
  padding: 13px 13px 0;
  background-color: #fff;
  width: 218px;
}
.left-menu-box {
  height: 100%;
  overflow-y: overlay;
  margin-right: -15px;
  padding-right: 15px;
}
.left-label {
  height: 40px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  cursor: pointer;
  padding: 0 10px 0 5px;
  margin-bottom: 3px;
  font-size: 13px;
}
.left-label:hover {
  /* color: #1d99ff; */
  background-color: #f2f3f5;
}
.left-children-cell {
  padding-left: 55px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  margin-bottom: 3px;
  user-select: none;
  font-size: 13px;
}
.left-children-cell:hover {
  /* color: #1d99ff; */
  background-color: #f2f3f5;
}
.left-children-cell-true {
  color: #1d99ff;
  background-color: #f2f3f5;
}

.item-box {
  position: relative;
  width: 300px;
  padding: 25px;
  /* border: 1px solid #ccc; */
  display: inline-block;
  margin: 0 25px 25px 0;
  border-radius: 12px;
  vertical-align: top;
  background-color: #fff;
  box-shadow: 0 0 5px 3px #eee;
}
.item-box-true {
  box-shadow: 0 0 5px 3px #8fc9f9;
}
.item-box-title {
  margin-bottom: 18px;
}
.item-top-img {
  width: 100%;
  height: 150px;
}
.item-top-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px;
}
.item-cell-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding: 10px 0;
}
.item-cell-img {
  width: 70px;
  height: 70px;
}
.item-button-box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
}

.handle-button {
  /* display: flex;
	align-items: center;
	justify-content: center;
	height: 24px; */

  padding: 2px 9px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;
  font-size: 13px;
  color: #40a9ff;

  border: 1px solid #40a9ff;
  cursor: pointer;
}
.handle-button:hover {
  background-color: #40a9ff;
  color: #fff;
}

/* 设置左侧列滚动条开始 */
/* 滚动条整体 */
.left-menu-box::-webkit-scrollbar {
  /* height决定横向scrollbar的高度，width决定纵向滚动条的宽度 */
  /* height:30px; */
  width: 7px;
  /* 默认：滚动条透明底色 */
  background-color: transparent;
}
/* 滚动条滑块 */
.left-menu-box::-webkit-scrollbar-thumb {
  /* 圆角 */
  border-radius: 10px;
  /* 滑块自身颜色 透明 */
  background-color: transparent;
}
/* 当鼠标hover时 */
.big-menu-box:hover .left-menu-box::-webkit-scrollbar {
  /* 底色 */
  /* background-color:#f3f3f3 !important; */
}
.big-menu-box:hover .left-menu-box::-webkit-scrollbar-thumb {
  /* 滑块颜色 */
  background-color: #999 !important;
}
.left-menu-box::-webkit-scrollbar {
  /* display:none; */
  background-color: transparent;
}
/* 设置左侧列滚动条结束 */

.tab-box {
  width: 120px;
  height: 36px;
  line-height: 34px;
  text-align: center;
  background-color: #fff;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid transparent;
  user-select: none;
}
.tab-box-true {
  border: 1px solid #1d99ff;
  color: #1d99ff;
}

.nav-icon {
  color: #666;
  font-size: 12px;
  margin-right: 7px;
}

.gzh-select-box {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  min-height: 36px;
  overflow: hidden;
  padding-top: 10px;
}
.gzh-select-box-show {
  height: auto;
}
.gzh-select-box-hidden {
  max-height: 105px;
}
.gzh-select-cell {
  color: #99918e;
  border: 1px solid #99918e;
  font-size: 12px;
  border-radius: 6px;
  padding: 3px 3px 3px 8px;
  margin-right: 15px;
  margin-bottom: 10px;
  cursor: default;
  position: relative;
}
.gzh-select-cell-a {
  color: #101010;
  border: 1px solid #101010;
}
.gzh-select-cell-d {
  color: #e85a32;
  border: 1px solid #e85a32;
}

.gzh-hover:hover .gzh-hover-icon {
  display: block;
}
.gzh-hover-icon {
  display: none;
  position: absolute;
  right: 3px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 17px;
  background-color: #fff;
  cursor: pointer;
}

.select-icon {
  position: absolute;
  right: -6px;
  top: -6px;
  z-index: 3;
  font-size: 16px;
  cursor: pointer;
  background-color: #fff;
}
.text_p {
  margin-bottom: 0px;
  margin-top: 5px;
  text-indent: 1em;
}
</style>
